import httpClient from './httpClient';
import store from 'redux/configureStore';
import axios from 'axios';
const FileDownload = require('js-file-download');

export const securityCreateToken = (params) => {
    return httpClient
        .post('/api/v2/admin/security/get_token', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const securityGetUsers = () => {
    return httpClient
        // .get('/api/v2/admin/users')
        // .get('/api/v2/admin/user?help=false&count=false&page=1&itemsOnPage=5000&sort=%5B%5D&filter=%5B%5D')
        .get('/api/v2/admin/account?help=false&count=false&page=1&itemsOnPage=9999')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getUsersByOrganization = (orgId) => {
    return httpClient
        .get(`/api/v2/admin/account/${orgId}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getCombinedUsers = () => {
    return httpClient
        .get('/api/v2/admin/user?help=false&count=false&page=1&itemsOnPage=9999&sort=%5B%5D&filter=%5B%5D')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const makeLogout = () => {
    const accessToken = store.getState().auth.wsseToken.accessToken;
    return httpClient
        .post('api/v2/admin/logout', { accessToken })
        .then((res) => res.data)
        .catch((e) => {
            throw e.message;
        });
};

export const refreshApiToken = (params) => {
    return httpClient
        .post('/api/v2/admin/refresh_token', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.message;
        });
};

export const getProfile = () => {
    return httpClient
        .get('/api/v2/profile/')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getUserLimits = (id) => {
    return httpClient
        .get(`/api/v2/admin/users/${id}/settings`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const changeUserLimits = (id, params) => {
    const {webLimit, twitterLimit, facebookLimit, rssLimit, youtubeLimit, googleOzmosysLimit, instagramLimit} = params;
    return httpClient
        .get(`/api/v2/admin/account/${id}/edit_source_limit?webLimit=${webLimit}&twitterLimit=${twitterLimit}&facebookLimit=${facebookLimit}&rssLimit=${rssLimit}&youtubeLimit=${youtubeLimit}&googleOzmosysLimit=${googleOzmosysLimit}&instagramLimit=${instagramLimit}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const changeUserPermissions = (id, params) => {
    const {roles} = params;
    let url = `/api/v2/admin/user/${id}/edit_roles?`;
    roles.length > 0 && roles.map(role => {
        url += `roles%5B%5D=${role}&`;
    });
    return httpClient
        .get(url)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const refreshFacebookAccounts = () => {
    return httpClient
        .get('/api/v2/admin/users/reactivate_fb_resources')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getFacebookAccountList = () => {
    return httpClient
        .get('/api/v2/admin/user/facebook_account_list?help=false&count=false&page=1&itemsOnPage=9999')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteCompany = (id) => {
    return httpClient
        .delete(`/api/v2/admin/global/company/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteSourceFromAdding = (params) => {
    return httpClient
        .post(`/api/v2/admin/global/drop_item`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const createCompany = (params) => {
    return httpClient
        .post(`/api/v2/companies/create`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};


export const getCompanies = () => {
    return httpClient
        .get('/api/v2/admin/global/companies')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

// export const getCategories = () => {
//     return httpClient
//         .get('/api/v2/admin/global/categories')
//         .then((res) => res.data)
//         .catch((e) => {
//             throw e.response.data.content;
//         });
// };

export const getCompanyById = (id) => {
    return httpClient
        .get(`/api/v2/admin/global/company/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getCompanyPreview = (params) => {
    return httpClient
        .post('/api/v2/admin/global/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        })
};

export const getEditCompanyPreview = (id) => {
    return httpClient
        .get(`/api/v2/admin/global/edit/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const submitCompanyCreation = (params) => {
    return httpClient
        .post(`/api/v2/admin/global/create_company`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const submitCompanyUpdate = (params, id) => {
    return httpClient
        .patch('/api/v2/admin/global/edit/' + id, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getRssPreviewForOrg = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_rss/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        })
};

export const getYoutubePreviewForOrg = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_youtube/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        })
};

export const getWebSiteForAddingToCompany = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_web/get_vs', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getWebPreviewForAddingToCompany = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_web/preview_web_resource_in_vs', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getWebNewsForAddingToCompany = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_web/get_web_preview', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getCompaniesFbAutocomplete = (params) => {
    return httpClient
        .post('/api/v2/admin/global/facebook_find_pages', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getFacebookPreviewForOrg = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_facebook/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        })
};

export const getTwitterPreviewForOrg = (params) => {
    return httpClient
        .post('/api/v2/admin/global/add_twitter/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        })
};

export const refreshFile = (html) => {
    return axios.post('http://localhost:3000/server/', { html });
};

export const createCategory = (params) => {
    return httpClient
        .post(`/api/v2/admin/global/create_category`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignCategoryToCompany = (params) => {
    return httpClient
        .post(`/api/v2/admin/global/category/assign`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteCategory = (id) => {
    return httpClient
        .delete(`/api/v2/admin/global/category/` + id)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const editCategoryName = (params, id) => {
    return httpClient
        .patch(`/api/v2/admin/global/edit_category/` + id, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignCategoriesToUser = (id, params) => {
    return httpClient
        .patch('/api/v2/corporate/assign_alerts/' + id, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignUsersToCategories = (id, params) => {
    return httpClient
        .patch('/api/v2/corporate/assign_alerts/' + id, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getAllProducts = () => {
    return httpClient
        .get('/api/v2/admin/user_type?help=false&count=false&page=1&itemsOnPage=9999')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getProductById = (id) => {
    return httpClient
        .get(`/api/v2/admin/user_type/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const createProduct = (params) => {
    return httpClient
        .post(`/api/v2/admin/user_type/create`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteProduct = (id) => {
    return httpClient
        .delete(`/api/v2/admin/user_type/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateProductById = (id, params) => {
    return httpClient
        .patch(`/api/v2/admin/user_type/${id}`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateUserProductType = (userId, typeId) => {
    return httpClient
        .patch(`/api/v2/admin/user/${userId}/add_user_type/${typeId}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getNudgeEmails = (id) => {
    return httpClient
        .get(`/api/v2/admin/nudge?help=false&count=false&page=1&itemsOnPage=9999`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getNudgeEmailAssignedUsers = (id) => {
    return httpClient
        .get(`/api/v2/admin/nudge/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getNudgeEmailPreview = (id) => {
    return httpClient
        .get(`/api/v2/admin/nudge/${id}/content`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};


export const sendNudgeEmail = (id) => {
    return httpClient
        .get(`/api/v2/admin/nudge/${id}/send`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteNudgeEmail = (id) => {
    return httpClient
        .delete(`/api/v2/admin/nudge/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getStatisticsCsv = () => {
    return httpClient
        .get(`/api/v2/admin/account/std_statistics`)
        .then((res) => {
            console.log(res.data)
            console.log(res.headers['content-disposition'])
            let headerLine = res.headers['content-disposition'];
            let name = headerLine.substring(headerLine.indexOf('=') + 1, headerLine.indexOf('.csv') + 4);
            console.log(name)
            console.log(headerLine)
            FileDownload(res.data, `${name ? name : 'entity-statistics.csv'}`);
        })
        .catch((e) => {
            throw e.response.data.content;
        });
};


export const getSystemStatus = () => {
    return httpClient
        .get(`/api/v2/admin/security/system`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};
